<template>
  <li class="lz-resource-action">
    <b-button @click="$emit('click')">
      <b-icon v-if="icon" :icon="icon" scale="0.8" aria-hidden="true"></b-icon>
      {{ label }}
    </b-button>
  </li>
</template>

<script>
export default {
  // A single action in a <resource-card> footer (Open / Videos / Files / ...).
  name: 'HomeResourceAction',
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  }
}
</script>
